import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 4% 4%;
  width: 62%;
  height: 70%;
  border-radius: 20px;
  background-color: ${Variables.colorWhite};
  box-shadow: 5px 5px 5px 4px rgba(0, 0, 0, 0.2);

  @media (max-width: 820px) {
    width: 82%;
    height: 45%;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  width: 25px;
  height: 25px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

export const ContainerVideo = styled.div`
  width: 100%;
`;
